export const DIFFICULTY_LEVELS = {
  INCUBE_1: {
    id: 'incube_1',
    label: 'Incube Level 1',
    description: 'Foundation level - Basic concepts and introductory skills',
    color: 'var(--secondary-blue, #003D7A)', // Secondary Blue
    prerequisites: [],
    targetAudience: 'Absolute beginners with no prior experience',
    expectedDuration: '1-2 weeks',
    skillLevel: 'Foundation'
  },
  
  INCUBE_2: {
    id: 'incube_2',
    label: 'Incube Level 2',
    description: 'Basic level - Fundamental skills and understanding',
    color: 'var(--accent-blue, #00B1FF)', // Accent Blue
    prerequisites: ['Incube Level 1'],
    targetAudience: 'Learners with basic foundation knowledge',
    expectedDuration: '2-3 weeks',
    skillLevel: 'Basic'
  },
  
  INCUBE_3: {
    id: 'incube_3',
    label: 'Incube Level 3',
    description: 'Elementary level - Building on basic concepts',
    color: 'var(--primary-blue, #0066CC)', // Primary Blue
    prerequisites: ['Incube Level 2'],
    targetAudience: 'Learners with elementary understanding',
    expectedDuration: '2-4 weeks',
    skillLevel: 'Elementary'
  },
  
  INCUBE_4: {
    id: 'incube_4',
    label: 'Incube Level 4',
    description: 'Pre-intermediate level - Developing practical skills',
    color: 'var(--secondary-blue, #003D7A)', // Secondary Blue
    prerequisites: ['Incube Level 3'],
    targetAudience: 'Learners ready for more practical applications',
    expectedDuration: '3-4 weeks',
    skillLevel: 'Pre-Intermediate'
  },
  
  INCUBE_5: {
    id: 'incube_5',
    label: 'Incube Level 5',
    description: 'Intermediate level - Solid working knowledge',
    color: 'var(--primary-blue, #0066CC)', // Primary Blue
    prerequisites: ['Incube Level 4'],
    targetAudience: 'Learners with working knowledge seeking to expand skills',
    expectedDuration: '4-5 weeks',
    skillLevel: 'Intermediate'
  },
  
  INCUBE_6: {
    id: 'incube_6',
    label: 'Incube Level 6',
    description: 'Upper-intermediate level - Advanced applications',
    color: 'var(--secondary-blue, #003D7A)', // Secondary Blue
    prerequisites: ['Incube Level 5'],
    targetAudience: 'Competent learners ready for complex challenges',
    expectedDuration: '4-6 weeks',
    skillLevel: 'Upper-Intermediate'
  },
  
  INCUBE_7: {
    id: 'incube_7',
    label: 'Incube Level 7',
    description: 'Advanced level - Professional competency',
    color: 'var(--accent-blue, #00B1FF)', // Accent Blue
    prerequisites: ['Incube Level 6'],
    targetAudience: 'Advanced learners seeking professional mastery',
    expectedDuration: '5-6 weeks',
    skillLevel: 'Advanced'
  },
  
  INCUBE_8: {
    id: 'incube_8',
    label: 'Incube Level 8',
    description: 'Professional level - Expert application',
    color: 'var(--gradient, linear-gradient(135deg, #5A00A3 0%, #F52AA3 100%))', // Gradient
    prerequisites: ['Incube Level 7'],
    targetAudience: 'Professional practitioners seeking expertise',
    expectedDuration: '6-8 weeks',
    skillLevel: 'Professional'
  },
  
  INCUBE_9: {
    id: 'incube_9',
    label: 'Incube Level 9',
    description: 'Expert level - Mastery and leadership',
    color: 'var(--primary-blue, #0066CC)', // Primary Blue
    prerequisites: ['Incube Level 8'],
    targetAudience: 'Experts ready to lead and innovate',
    expectedDuration: '6-8 weeks',
    skillLevel: 'Expert'
  },
  
  INCUBE_10: {
    id: 'incube_10',
    label: 'Incube Level 10',
    description: 'Master level - Innovation and thought leadership',
    color: 'var(--secondary-blue, #003D7A)', // Secondary Blue
    prerequisites: ['Incube Level 9'],
    targetAudience: 'Master practitioners and thought leaders',
    expectedDuration: '8-10 weeks',
    skillLevel: 'Master'
  }
};

export const DIFFICULTY_OPTIONS = Object.values(DIFFICULTY_LEVELS).map(level => ({
  value: level.label,
  label: level.label,
  description: level.description,
  color: level.color,
  skillLevel: level.skillLevel
}));

export const getDifficultyLevel = (levelString) => {
  return Object.values(DIFFICULTY_LEVELS).find(level => level.label === levelString) || null;
};

export const getDifficultyColor = (levelString) => {
  const level = getDifficultyLevel(levelString);
  return level ? level.color : '#6c757d';
};

export const getDifficultyNumber = (levelString) => {
  const match = levelString.match(/Incube Level (\d+)/);
  return match ? parseInt(match[1]) : 0;
};

export const getNextLevel = (currentLevel) => {
  const currentNumber = getDifficultyNumber(currentLevel);
  if (currentNumber < 10) {
    return `Incube Level ${currentNumber + 1}`;
  }
  return null;
};

export const getPreviousLevel = (currentLevel) => {
  const currentNumber = getDifficultyNumber(currentLevel);
  if (currentNumber > 1) {
    return `Incube Level ${currentNumber - 1}`;
  }
  return null;
};

export const isValidProgression = (fromLevel, toLevel) => {
  const fromNumber = getDifficultyNumber(fromLevel);
  const toNumber = getDifficultyNumber(toLevel);
  
  // Allow progression to same level, next level, or any lower level
  return toNumber <= fromNumber + 1;
};

export const getProgressionPath = (targetLevel) => {
  const targetNumber = getDifficultyNumber(targetLevel);
  const path = [];
  
  for (let i = 1; i <= targetNumber; i++) {
    path.push(`Incube Level ${i}`);
  }
  
  return path;
};

// Migration helper for old difficulty levels
export const migrateLegacyDifficulty = (oldLevel) => {
  const migrationMap = {
    'Beginner': 'Incube Level 1',
    'Intermediate': 'Incube Level 5',
    'Advanced': 'Incube Level 8'
  };
  
  return migrationMap[oldLevel] || oldLevel;
};